/*global angular, _*/

var nodeHelper = angular.module('nodeHelper', []);
nodeHelper.factory('nodeHelper', ['settings', function (settings) {
  'use strict';
  var that = {};

  that.findRecursive = function (contents, contentKey) {

    function findNode(currentNode, key) {

      let i,
        currentChild,
        result;

      if (key === currentNode.key) {

        return currentNode;

      } else if (currentNode.contents) {

        for (i = 0; i < currentNode.contents.length; i += 1) {
          currentChild = currentNode.contents[i];
          result = findNode(currentChild, key);
          if (result !== false) {
            return result;
          }
        }
      }
      return false;
    }

    let result;

    contents.forEach((content) => {

      let resultInChild = findNode(content, contentKey);

      if (resultInChild) {
        result = resultInChild;
      }
    });
    return result;
  };
  return that;
}]);
module.exports = nodeHelper;



// WEBPACK FOOTER //
// ./web/js/module/nodeHelper/nodeHelper.js